// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZEcr","colBig":"styles_colBig__3UzGp","colSmall":"styles_colSmall__M7d61","shopifyNameWrapper":"styles_shopifyNameWrapper__22HQY"};